import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { CODE_LANGUAGES } from '../lib/highlight';

/**
 * NodeView for CodeBlockLowlight — renders the `<pre><code>` (lowlight decorates
 * its content) plus a GitLab-style language dropdown in the block's top-right
 * corner. Picking a language sets the node's `language` attr, which drives both
 * live highlighting and the fenced-markdown info string (```json) on save.
 */
export function CodeBlockView({ node, updateAttributes, editor }: NodeViewProps) {
  const language: string = node.attrs.language ?? '';
  return (
    <NodeViewWrapper className="code-block">
      <select
        className="code-lang"
        contentEditable={false}
        value={language}
        disabled={!editor.isEditable}
        aria-label="Code block language"
        // don't let the click move the editor selection / focus the doc
        onMouseDown={(e) => e.stopPropagation()}
        onChange={(e) => updateAttributes({ language: e.target.value })}
      >
        {CODE_LANGUAGES.map((l) => (
          <option key={l.value || 'plain'} value={l.value}>
            {l.label}
          </option>
        ))}
      </select>
      <pre>
        <NodeViewContent<'code'> as="code" />
      </pre>
    </NodeViewWrapper>
  );
}
